import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login-enter-phoneNumber',
    component: () => import('../views/Login/Login-add-phone-number.vue')
  },
  {
    path: '/register',
    name: 'Register-enter-phoneNumber',
    component: () => import('../views/Login/Login-add-phone-number.vue')
  },
  {
    path: '/password',
    name: 'Login-enter-password',
    component: () => import('../views/Login/Login-enter-password.vue')
  },
  {
    path: '/account',
    name: 'Account-overview',
    component: () => import('../views/Account-overview.vue')
  },
  {
    path: '/payment',
    name: 'Add Payment Method',
    component: () => import('../views/Payment/addPaymentMethod.vue')
  },
  {
    path: '/ThreeDsTwoResponse/:sessionId/acs',
    name: 'ThreeDS Two Response',
    component:() => import('../views/Payment/ThreeDsTwoResponse.vue')
  },
  {
    path: '/ThreeDsOneResponse/acs',
    name: 'ThreeDs One Response',
    component:() => import('../views/Payment/ThreeDsOneResponse.vue')
},
{
    path: '/otp',
    name: 'Register-enter-otp',
    component: () => import('../views/Register/Register-enter-otp.vue')
  },
  {
    path: '/details',
    name: 'Register-enter-details',
    component: () => import('../views/Register/Register-enter-details.vue')
  },
  {
    path: '/create-pincode',
    name: 'Register-create-pincode',
    component: () => import('../views/Register/Register-create-pincode.vue')
  },
  {
    path: '/confirm-pincode',
    name: 'Register-confirm-pincode',
    component: () => import('../views/Register/Register-confirm-pincode.vue')
  },
  {
    path: '/forgot-password',
    name: 'Forgot-password',
    component: () => import('../views/Login/Login-forgot-password.vue')
  },
  {
    path: '/purchases',
    name: 'Purchases-overview',
    component: () => import('../views/Purchase/Purchases-Overview.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/About/Privacy.vue')
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/About/Terms.vue')
  },
  {
    path: '/purchases/:orderId',
    name: 'PurchasesDetail',
    component: () => import('../views/Purchase/PurchaseDetail.vue')
  },
  {
    path: '/purchase-details/:orderId/more-info',
    name: 'MoreInfo',
    component: () => import('../views/Purchase/OrderMoreInfo.vue'),
  }
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = ['/password', '/login', '/register'];
  const authpage = !publicPages.includes(routeTo.path);
  const loggeduser = localStorage.getItem('customer');
  if (authpage && !loggeduser && routeTo.path === '/login') {
    return next('/login');
  }
  else if (authpage && routeTo.path === '/register') {
    return next('/register');
  }
  else if (routeTo.path === '/password') {
    const inputMobile = localStorage.getItem('inputMobile');
    if (!inputMobile) {
      return next('/login');
    }
  }

  next();
})

export default router
